import usePermission from '../../../hook/usePermission'
import {SupplierMappingDetails} from '../context'
import SupplierMappingTable from '../sections/tables/SupplierMappingTable'
import useSupplierMappingDetailsList from '../hooks/useSupplierMappingDetailsList'
import SupplierMappingHeader from '../sections/headers/SupplierMappingDetailsHeader'
import useSupplierMappingDetailsOperations from '../hooks/useSupplierMappingDetailsOperations'
import useGetBrandsDropdown from '../hooks/useGetBrandsDropdown'
import useGetProductsDropdown from '../hooks/useGetProductsDropdown'
import {useState} from 'react'
import {Pagination} from '../../../utils/pagination'

const SupplierDetails = () => {
  const {hasPermission} = usePermission()
  const [checkedRows, setCheckedRows] = useState<any>([])
  const {
    usersMappingsList,
    isLoading: isLoadingUsersMappingsList,
    filters,
    onSearch,
    onSortingChange,
    onBrandFilterChange,
    onPageChange,
    pagination,
  } = useSupplierMappingDetailsList(setCheckedRows)

  const {allBrands, isLoading: isLoadingAllBrands} = useGetBrandsDropdown()

  const {onAddProducts, onDeleteProducts, isOperationLoading} =
    useSupplierMappingDetailsOperations()

  const {
    allProducts,
    isLoading: isLoadingAllProducts,
    onSearchProducts,
    onPageChangeProducts,
    productPagination,
  } = useGetProductsDropdown()

  const hasWritePermission = hasPermission('supplier_users', 'write') || true

  const contextValue = {
    hasWritePermission,

    supplierUsersList: usersMappingsList,
    isLoading: isLoadingUsersMappingsList,
    filters: filters,
    onSearch: onSearch,
    onSortingChange: onSortingChange,
    onBrandFilterChange: onBrandFilterChange,

    allBrands,
    isLoadingAllBrands,

    allProducts,
    isLoadingAllProducts,
    onSearchProducts,
    onPageChangeProducts,
    productPagination,

    onAddProducts,
    onDeleteProducts,
    isOperationLoading,

    checkedRows,
    setCheckedRows,
  }

  return (
    <SupplierMappingDetails.Provider value={contextValue}>
      <SupplierMappingHeader />
      <SupplierMappingTable />
      <Pagination onPageChange={onPageChange} pagination={pagination} />
    </SupplierMappingDetails.Provider>
  )
}

export default SupplierDetails
